import styled from "@emotion/native";
import { AppTheme } from "../../../../utils/theme";

export const LabelContainer = styled.View(
	{
		paddingBottom: 40,
		paddingTop: 25,
		paddingHorizontal: 20,
	},
	({ theme }: any) => {
		const {
			color: { backgroundAccent },
		} = theme as AppTheme;
		return {
			backgroundColor: backgroundAccent,
		};
	}
);
